import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Demographics } from 'src/app/models/demographics';
import { ScreeningDraft } from 'src/app/models/screeningDraft';
import { Screening, ScreeningInvite, ScreeningDupeCheckModel } from 'src/app/models/screeningInvite';
import { SearchFee, SearchPackage, SearchFeeLookupPayload } from 'src/app/packages-module/models/searchPackage';
import { AuthService } from 'src/app/services/auth.service';
import { ScreeningDraftService } from '../../services/screening-draft.service';
import { ScreeningService } from '../../services/screening.service';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { PropertyService } from 'src/app/property-module/services/property.service';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { Client, ClientLocation, ClientBillingTypes } from 'src/app/clients-module/models/clientLocation';
import { forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { PBUser } from 'src/app/users-module/models/pb-user';
import { UserLight } from 'src/app/users-module/models/userLight';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OneTimePaymentModalComponent } from 'src/app/shared-components-module/payments/one-time-payment-modal/one-time-payment-modal.component';
import { GuestPaymentModalComponent } from 'src/app/shared-components-module/payments/guest-payment-modal/guest-payment-modal.component';
import { PaymentsService } from 'src/app/services/payments.service';
import { take, tap } from 'rxjs/operators';
import { PaymentMethod } from 'src/app/models/PaymentModels';
import { OneTimePaymentDraftComponent } from 'src/app/shared-components-module/payments/one-time-payment-draft/one-time-payment-draft.component';

@Component({
  selector: 'app-create-review-order',
  templateUrl: './create-review-order.component.html',
  styleUrls: ['./create-review-order.component.less']
})
export class CreateReviewOrderComponent implements OnInit {


  @Output() public phaseComplete: EventEmitter<number> = new EventEmitter();
  
  public get directOrderDemographics() : ScreeningDraft {
    return this.drafts.directOrderDemographics;
  }
    
  public get additionalFees() : SearchFee[] {
    return this.drafts.additionalFees;
  }
  
  package: SearchPackage;
  client : Client;
  property : ClientLocation;
  user: UserLight;
  loading: boolean = true;
  canProceed : boolean = true;
  locationPmtMethods : PaymentMethod[];
  dupeDetected : boolean = false;

  isSaving: boolean = false;
  
  public get packageCost(): number {
    try {
      if (this.drafts.clientPackageOverrides) {
        const override = this.drafts.clientPackageOverrides.find(spo => {
          return spo.searchPackageId === this.package.id;
        });
        if (override) {
          this.package.cost = override.clientPackageCost;
        }
      }
      return this.package.cost;
    } catch (error) {
      this.screening.WriteLogToRIQ({
        loggerMessage: "OVERRIDES-ERROR",
        draftData: {
          id: this.drafts.directOrderDemographics.id,
          fn: this.drafts.directOrderDemographics.firstName,
          ln: this.drafts.directOrderDemographics.lastName,
          ovrds: this.drafts.clientPackageOverrides,
          pkg: this.package,
          err: error
        }
      })
    }
  }
  

  public get reportCost() : number {
    let cost = 0;
    if(this.drafts.additionalFees && this.drafts.additionalFees.length > 0){
      cost = this.drafts.additionalFees.map(fee =>{return fee.amount}).reduce((sum,current)=> sum + current,0);
      cost+= this.package.cost;
    }else {
      cost = this.package.cost;
    }
    return cost;
  }


  constructor(public toastr : ToastrService,
    public auth: AuthService, 
    public screening: ScreeningService,
    private drafts: ScreeningDraftService, 
    public clients: ClientService, 
    public properties : PropertyService, 
    public pkgs : SearchPackageService,
    public pmts : PaymentsService,
    public modalService : NgbModal) { }

  ngOnInit() {
    forkJoin([
      this.clients.GetClientById(this.directOrderDemographics.clientId), 
      this.properties.FetchProperty(this.directOrderDemographics.clientLocationId), 
      this.pkgs.FetchSearchPackageById(this.directOrderDemographics.searchPackageId),
      this.auth.FetchUser(!this.directOrderDemographics.requestingUserId ? this.directOrderDemographics.userId : this.directOrderDemographics.requestingUserId),
      this.pkgs.GetClientSearchPackageOverrideList(this.drafts.directOrderDemographics.clientId)
    ]).subscribe(results =>{
      this.client = results[0];
      this.property = results[1];
      this.package = Object.assign(new SearchPackage(),results[2][0]);
      this.user = results[3];
      this.drafts.clientPackageOverrides = results[4];
    },(err: any)=>{
      this.toastr.error('Error loading data for draft');
      this.canProceed = false;
    },()=>{

      this.screening.WriteLogToRIQ({
        loggerMessage : "UI-OVERRIDES",
        draftData : {
          id : this.drafts.directOrderDemographics.id,
          fn : this.drafts.directOrderDemographics.firstName,
          ln : this.drafts.directOrderDemographics.lastName,
          ovrds : this.drafts.clientPackageOverrides,
          pkg: this.package,
          cst: this.packageCost
        }
      })
      let lookup = new SearchFeeLookupPayload();
      lookup.county = this.drafts.directOrderDemographics.county;
      lookup.state = this.drafts.directOrderDemographics.state;
      lookup.searches = this.package.searches.filter(srch=>{ return srch.searchType == 2});
  
      this.pkgs.GetFeesForSearchPackage(lookup).pipe(
        take(1),
        tap((res: SearchFee[]) => this.drafts.additionalFees = res)
      ).subscribe(null,()=>{
        this.toastr.error('Additional fees may be added to your report cost based on the criminal searches when you submit it.', 'Error fetching search Fees for your package');
        this.canProceed = false;
      },()=>{ this.loading = false;});

      this.pmts.FetchPaymentMethods(this.property.id).pipe(take(1),tap(_ =>{
        this.locationPmtMethods = _;
      })).subscribe(null,null,()=>{
        console.log('pmt methods loaded',this.locationPmtMethods);
      });
    });
  }

  public navToPhase(phase: number) : void {
    this.phaseComplete.next(phase);
  }

  public makeCardPayment(): void {
    const modalRef = this.modalService.open(OneTimePaymentDraftComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.name = 'OneTimePaymentDraftComponent';
    modalRef.componentInstance.clientId = this.client.id;
    modalRef.componentInstance.propertyId = this.property.id;
    modalRef.componentInstance.amount = this.reportCost;
    modalRef.componentInstance.draftId = this.directOrderDemographics.id;
    modalRef.componentInstance.paymentProcessed.subscribe(ev=>this.convertDraftToReport());
    modalRef.componentInstance.paymentCancel.subscribe( ev=>{ 
      this.directOrderDemographics.posReportCost = this.reportCost;
      modalRef.close();
      this.fireGuestPayment();
    })
  }

   public launchGuestPaymentModal(paymentUrl : string) {
     // Go Get a guest payment url.
    console.log('loading pmt iframe for: ', paymentUrl);
    const modalRef = this.modalService.open(GuestPaymentModalComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.name = 'GuestPaymentModalComponent';
    modalRef.componentInstance.aptexxGuestPaymentLink = paymentUrl;
    modalRef.componentInstance.processed$.subscribe(ev=>this.convertDraftToReport());
  }

  saveAndContinue(): void {
    this.isSaving = true;
    let dupe = new ScreeningDupeCheckModel();
    dupe.clientLocationId = this.directOrderDemographics.clientLocationId;
    dupe.dateOfBirth = this.directOrderDemographics.dob;
    dupe.firstName = this.directOrderDemographics.firstName;
    dupe.lastName = this.directOrderDemographics.lastName;
    dupe.sSN = this.directOrderDemographics.ssn;
    this.screening.ScreeningDupeCheck(dupe).pipe(take(1),tap((_:boolean)=>{
      if(_){
        this.dupeDetected = true;
        this.toastr.error(`${this.directOrderDemographics.firstName}${this.directOrderDemographics.lastName} has been screened for ${this.property.locationName} within the last 30 days and cannot be screened.`, 'Duplicate Report Exists!', {closeButton: true, disableTimeOut: true});
      }
    })).subscribe(null,null,()=>{
      if(!this.dupeDetected){
        this.drafts.directOrderDemographics.draftBasePrice = this.packageCost;
        this.drafts.directOrderDemographics.posReportCost = this.reportCost;
        if(this.client.billingType == ClientBillingTypes.POS && !this.drafts.directOrderDemographics.paymentId){
          // DISABLE NS for now
          this.loading = true;
          this.isSaving = false;
          this.drafts.CreateNetsuiteInvoiceForDraft().pipe(take(1),tap((_:any) =>{
            // this.package.cost = <number>_.posReportCost;
            this.directOrderDemographics.posReportCost = this.reportCost;
            this.loading = false;
          },(err:any)=>{
            this.toastr.error('');
          })).subscribe((scc: any)=>{
            this.loading = false;

         // do they have any cards on file? 
            if(this.locationPmtMethods.filter(pmt =>{ return pmt.isActive;}).length > 0){
              this.makeCardPayment();
            }else{
              // this.fireGuestPayment(); RIQ-3199 : we don't do that anymore.. no more guest pmts. gonna leave the code intact and just turn it off until this sails along for a cpl months.
              this.toastr.error('A valid payment method must be added to your account under account settings in order to run reports. If you are unable to add a payment method please contact your account administrator for assistance','Payment Method Required',{ closeButton: true, timeOut: 60 });
            }
          },(err:any)=>{
              this.toastr.error('We ran into a problem creating a payment for your draft. please contact support for further details', 'Screening Draft Error');
              this.loading = false;
          },()=>{
            this.loading = false;
          });
 
        }else{
          this.convertDraftToReport();
        }
      }
    });
  }

  fireGuestPayment(){
    this.pmts.FetchGuestPaymentURLForDraft(this.drafts.directOrderDemographics).pipe(take(1),tap(_=>{
      this.launchGuestPaymentModal(_.paymentUrl)
    })).subscribe(null,(err: any)=>{
      this.toastr.error('There was an error loading your payment window. Please contact support if the issue persists.', 'Payment Error');
    })
  }

  convertDraftToReport(){
    console.log('PAYMENT HANDLED.. S"GO!!!');
    this.loading = true;
    this.modalService.dismissAll();
    this.drafts.ConvertDraftToReport().pipe(take(1),tap(_=>{
      this.drafts.convertedDraft = _;
    })).subscribe(null,(err: any)=>{
      this.toastr.error('There was an saving your screening report','Report Save Error', { closeButton:true, disableTimeOut:true })
    },()=>{
      this.loading = false;
      this.phaseComplete.next(4);
    });
  }

}
